import Report from "src/components/report/Report";


const ReportPage = () => {
    return <Report/>
}

export default ReportPage;

